import HttpCliente from '../HttpCliente';

export const getCompromisos = (token) => {
    return new Promise((resolve, reject) => {
    HttpCliente.get('/Compromiso/ObtenerCompromisos', {
        headers: {
            'Authorization': `Bearer ${token}`,
            'accept': 'text/plain'
            }
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error);
        });
    });
};  

export const getCompromisosUsuario = (token, id) => {
    return new Promise((resolve, reject) => {
    HttpCliente.get(`/Compromiso/ObtenerCompromisoCliente/${id}`, {
        headers: {
            'Authorization': `Bearer ${token}`,
            'accept': 'text/plain'
            }
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error);
        });
    });
};

export const postCompromiso = (token, compromiso) => {
    return new Promise((resolve, reject) => {
        HttpCliente.post('/Compromiso/Crear', compromiso, {
        headers: {
            'Authorization': `Bearer ${token}`,
            'accept': 'text/plain',
            'Content-Type': 'application/json',
            }
        }).then(response => {
            resolve(response.data);
            }).catch(error => {
            reject(error);
            });
    });
}

export const putCompromiso = (token, compromiso) => {
    return new Promise((resolve, reject) => {
        HttpCliente.put(`/Compromiso/EditarCompromiso`, compromiso, {
        headers: {
            'Authorization': `Bearer ${token}`,
            'accept': 'text/plain',
            'Content-Type': 'application/json',
            }
        }).then(response => {
            resolve(response.data);
            }).catch(error => {
            reject(error);
            });
    });
}

export const getCompromisoPorNormativa = (token, id) => {
    return new Promise((resolve, reject) => {
        HttpCliente.get(`/Compromiso/ObtenerCompromisoPorNormativa/${id}`, {
        headers: {
            'Authorization': `Bearer ${token}`,
            'accept': 'text/plain'
            }
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error);
        });
    });
};